import { render, staticRenderFns } from "./commissionView.vue?vue&type=template&id=0948cdc4&"
import script from "./commissionView.vue?vue&type=script&lang=js&"
export * from "./commissionView.vue?vue&type=script&lang=js&"
import style0 from "./commissionView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports